export const SUBDIRECTORIES = {
  member: "/member",
  team: "/team",
};

export const STATES = [
  { title: "Alabama", value: "US-AL" },
  { title: "Alaska", value: "US-AK" },
  { title: "Arizona", value: "US-AZ" },
  { title: "Arkansas", value: "US-AR" },
  { title: "California", value: "US-CA" },
  { title: "Colorado", value: "US-CO" },
  { title: "Connecticut", value: "US-CT" },
  { title: "Delaware", value: "US-DE" },
  { title: "Florida", value: "US-FL" },
  { title: "Georgia", value: "US-GA" },
  { title: "Hawaii", value: "US-HI" },
  { title: "Idaho", value: "US-ID" },
  { title: "Illinois", value: "US-IL" },
  { title: "Indiana", value: "US-IN" },
  { title: "Iowa", value: "US-IA" },
  { title: "Kansas", value: "US-KS" },
  { title: "Kentucky", value: "US-KY" },
  { title: "Louisiana", value: "US-LA" },
  { title: "Maine", value: "US-ME" },
  { title: "Maryland", value: "US-MD" },
  { title: "Massachusetts", value: "US-MA" },
  { title: "Michigan", value: "US-MI" },
  { title: "Minnesota", value: "US-MN" },
  { title: "Mississippi", value: "US-MS" },
  { title: "Missouri", value: "US-MO" },
  { title: "Montana", value: "US-MT" },
  { title: "Nebraska", value: "US-NE" },
  { title: "Nevada", value: "US-NV" },
  { title: "New Hampshire", value: "US-NH" },
  { title: "New Jersey", value: "US-NJ" },
  { title: "New Mexico", value: "US-NM" },
  { title: "New York", value: "US-NY" },
  { title: "North Carolina", value: "US-NC" },
  { title: "North Dakota", value: "US-ND" },
  { title: "Ohio", value: "US-OH" },
  { title: "Oklahoma", value: "US-OK" },
  { title: "Oregon", value: "US-OR" },
  { title: "Pennsylvania", value: "US-PA" },
  { title: "Rhode Island", value: "US-RI" },
  { title: "South Carolina", value: "US-SC" },
  { title: "South Dakota", value: "US-SD" },
  { title: "Tennessee", value: "US-TN" },
  { title: "Texas", value: "US-TX" },
  { title: "Utah", value: "US-UT" },
  { title: "Vermont", value: "US-VT" },
  { title: "Virginia", value: "US-VA" },
  { title: "Washington", value: "US-WA" },
  { title: "Washington, D.C.", value: "US-DC" },
  { title: "West Virginia", value: "US-WV" },
  { title: "Wisconsin", value: "US-WI" },
  { title: "Wyoming", value: "US-WY" },
];
